import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css"; 

function ViberAccount({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({
      ...prev,
      [name]: value
    }));
    if (isError[name]) {
      setIsError(prev => ({ ...prev, [name]: false }));
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!primaryDetails.viber_account) errors.viber_account = true;
    if (primaryDetails.viber_account !== 'No Viber Account') {
      if (!primaryDetails.viber_account_number) errors.viber_account_number = true;
      if (!primaryDetails.viber_account_name) errors.viber_account_name = true;
      // if (!primaryDetails.viber_community) errors.viber_community = true;
    }
    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = () => {
    if (validateForm()) {
      navigation.go("handling-and-merchant-concerns");
    } else {
      toast.error("Please fill in all required fields.");
    }
  };

  const handleBack = () => {
    navigation.previous(); 
  };

  const viberOptions = [
    "Has Viber Account",
    "No Viber Account",

  ];
  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">VIBER ACCOUNT</h4>
              <p className="form-desc">Description (optional)</p>
            </div>

            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  
                  {/* Viber Account */}
                  <Form.Group className="mb-5">
                    <Form.Label className="form-label">
                      Viber Account
                      <span className="form-required">*</span>
                    </Form.Label>

                    <Form.Select
                      name="viber_account"
                      value={primaryDetails.viber_account || ''}
                      onChange={handleInputChange}
                      className={`form-select${isError.viber_account ? ' form-input-error' : ''}`}
                    >
                      <option value="">Select viber account status</option>
                      {viberOptions.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Select>
                    {isError.viber_account && (
                      <div className="form-error">Viber account selection is required.</div>
                    )}
                  </Form.Group>

                      {/* Account Number on Viber */}
                      {primaryDetails.viber_account !== 'No Viber Account' && (
                      <Form.Group className="mb-4" controlId="viber_account_number">
                        <Form.Label className="form-label">
                          Account Number on Viber <span className="form-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="viber_account_number"
                          value={primaryDetails.viber_account_number || ""}
                          onChange={handleInputChange}
                          placeholder="Short answer text"
                          className={`form-input ${isError.viber_account_number ? "error" : ""}`}
                        />
                        {isError.viber_account_number && (
                          <div className="form-error">Please enter account number on Viber.</div>
                        )}
                      </Form.Group>
                      )} 

                      {/* Account Name on Viber */}
                      {primaryDetails.viber_account !== 'No Viber Account' && (
                      <Form.Group className="mb-4" controlId="viber_account_name">
                        <Form.Label className="form-label">
                          Account Name on Viber <span className="form-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="viber_account_name"
                          value={primaryDetails.viber_account_name || ""}
                          onChange={handleInputChange}
                          placeholder="Short answer text"
                          className={`form-input ${isError.viber_account_name ? "error" : ""}`}
                        />
                        {isError.viber_account_name && (
                          <div className="form-error">Please enter account name on Viber.</div>
                        )}
                      </Form.Group>
                      )} 

                      {/* Joined in Maya Mall Program Viber Community */}
                      {/* <Form.Group className="mb-4" controlId="viber_community">
                        <Form.Label className="form-label">
                          Joined in Maya Mall Program Viber Community <span className="form-required">*</span>
                        </Form.Label>
                        <Form.Select
                          name="viber_community"
                          value={primaryDetails.viber_community || ''}
                          onChange={handleInputChange}
                          className={`form-select${isError.viber_community ? ' form-input-error' : ''}`}
                        >
                          <option value="">Select community status</option>
                          {["Yes", "No"].map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))}
                        </Form.Select>
                        {isError.viber_community && (
                          <div className="form-error">
                            Please select if joined in Maya Mall Program Viber Community.
                          </div>
                        )}
                      </Form.Group> */}

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton onClick={handleBack} variant="back" className="form-btn variant-secondary">
                      ← Back
                    </AppButton>
                    <AppButton onClick={handleNext} variant="next" className="form-btn variant-primary">
                      Next →
                    </AppButton>
                  </div>

                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ViberAccount;
